import {
  Flex,
  FlexColumn,
  InputGroup,
  KeyIcon,
  SecondaryButton,
  useStyledTheme,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useState } from 'react';
import { SectionContainer, SectionHeader } from '../ManageDetailsSection';
import ChangePasswordSection from './ChangePasswordSection';

const ChangePasswordButton = styled(SecondaryButton)`${({ theme }) => `
  color: ${theme.colours.primary[1]};
  border-color: ${theme.colours.primary[1]};
  margin-top: auto;
  flex-shrink: 0;
`}`;

const SectionContent = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[3]};
  padding-top: ${theme.padding[3]};
  padding-bottom: ${theme.padding[5]};
  justify-content: space-between;
`}`;

const PasswordInfo = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[6]};
  margin-bottom: ${theme.padding[1]}
`}`;

export default function PasswordSection() {
  const theme = useStyledTheme();
  const [changingPassword, setChangingPassword] = useState(false);

  const [resetKey, setResetKey] = useState(0);
  const reset = () => {
    setResetKey((prevKey) => prevKey + 1);
  };

  const onChangingPassword = () => {
    setChangingPassword(true);
    reset();
  };

  const onCancel = () => {
    setChangingPassword(false);
  };

  const onChangedPassword = () => {
    reset();
  };

  return (
    <div>
      <SectionHeader>PASSWORD</SectionHeader>
      <SectionContainer>
        <InputGroup>
          <SectionContent>
            <PasswordInfo>
              <p>A secure password helps protect your account.</p>
              <p>••••••••••••••••</p>
            </PasswordInfo>
            <ChangePasswordButton small onClick={onChangingPassword} disabled={changingPassword}>
              <KeyIcon fill={theme.colours.primary[1]} />
              Change password
            </ChangePasswordButton>
          </SectionContent>
        </InputGroup>
      </SectionContainer>
      {changingPassword && <ChangePasswordSection key={resetKey} onChangedPassword={onChangedPassword} onCancel={onCancel} />}
    </div>
  );
}
